import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Lenis from '@studio-freight/lenis';
import { Toaster } from 'sonner';
import './i18n';
import './App.css';

import { CartProvider } from './contexts/CartContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Quiz from './pages/Quiz';
import Shop from './pages/Shop';
import About from './pages/About';
import Journal from './pages/Journal';
import Account from './pages/Account';
import RadianceProduct from './pages/RadianceProduct';
import BodyType from './pages/TigerCircle/BodyType';
import Beauty from './pages/TigerCircle/Beauty';

function AppContent() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 2,
      infinite: false,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/ritual" element={<Quiz />} />
            <Route path="/tiger-circle/tea" element={<Quiz />} />
            <Route path="/tiger-circle/body-type" element={<BodyType />} />
            <Route path="/tiger-circle/beauty" element={<Beauty />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/products/radiance" element={<RadianceProduct />} />
            <Route path="/about" element={<About />} />
            <Route path="/journal" element={<Journal />} />
            <Route path="/account" element={<Account />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

function App() {
  return (
    <CartProvider>
      <AppContent />
    </CartProvider>
  );
}

export default App;